export enum ActivityTypes {
  Tourism = "Turizam",
  Production = "Proizvodnja",
  Services = "Usluge",
}
